/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Team_Lifecycle_DeleteInputs */



/**
* | output |
* | --- |
* | "Delete the team" |
*
* @param {Perm_Team_Lifecycle_DeleteInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_team_lifecycle_delete = /** @type {((inputs?: Perm_Team_Lifecycle_DeleteInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Team_Lifecycle_DeleteInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалять команду")
	return /** @type {LocalizedString} */ ("Delete the team")
});